<script setup lang="ts">
defineProps<{
  icon: string
  label: string
}>()
</script>

<template>
  <p class="flex items-center justify-center gap-1.5">
    <UtilsIcon
      :name="icon"
      class="h-4 w-4 shrink-0"
      decoding="async"
      alt-text=""
    />
    <span class="text-[0.75rem] font-bold leading-none">
      {{ label }}
    </span>
  </p>
</template>
